import React from 'react';
import { useEffect } from 'react';

import bannerMobile from './media/bannerServiziMobile.jpeg';
import bannerDesktop from './media/bannerServiziDesktop.jpg';

function Servizi() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <div>
      <section className="h-full text-white bg-gray-900">
        <div className="container px-10 py-16 mx-auto sm:px-10 lg:px-10">
          <div className="gap-10 max-h-min lg:flex">
            <div className="">
              <div className="flex flex-col items-start justify-start gap-4">
                <span className="font-medium tracking-widest text-blue-400">
                  CONSULENZA
                </span>
                <h1 className="text-3xl text-balance">
                  SEVIZI DI INGEGNERIA NELL’AMBITO DELLA MOBILITA’ SOSTENIBILE
                </h1>
                <p>
                  Fin dalla fondazione eDriveLAB svolge attività di ingegneria
                  nell’ambito della mobilità sostenibile e nell’innovazione
                  tecnologica.
                  <br />
                  <br />
                  Seguiamo il cliente dall’idea sul foglio di carta, attraverso
                  un processo di progettazione e analisi, fino alla
                  prototipazione del veicolo.
                </p>
                <img src="" alt="" />
              </div>
              <img
                src={bannerMobile}
                alt="bannerMobile"
                className="lg:hidden"
              />
              <div className="flex flex-col items-start justify-start gap-4 pt-4">
                <span className="mt-4 font-medium tracking-widest text-blue-400">
                  PROGETTAZIONE
                </span>
                <h1 className="text-3xl">SVILUPPO BASATO SU MODELLI</h1>
                <div className="pl-4 border-l-4 border-l-blue-500">
                  <span className="text-xl font-bold ">Vehicle Simulation</span>
                  <p>
                    Strumenti di progettazione basati su modellazione di
                    veicolo, powertrain e strategie con particolare focus per i
                    componenti che costituiscono un sistema elettrificato.
                    Sosftware di veicolo generato automaticamente tramite Model
                    Design Development
                    <br />
                    <br />
                    La modellazione dei veicoli viene effettuata tramite lo
                    studio di:
                  </p>
                  <ul className="list-disc list-inside">
                    <li>Bilanciamento delle forze in gioco</li>
                    <li>Modello longitudinale / verticale</li>
                    <li>Modello 3D</li>
                  </ul>
                  <p>
                    Sviluppo di modelli efficienti per simulare l'intero ciclo
                    di guida
                  </p>
                </div>
                <div className="pl-4 border-l-4 border-l-blue-500">
                  <span className="text-xl font-bold">
                    EV Powertrain Layout
                  </span>
                  <p>
                    Simulazioni avanzate del gruppo propulsore per definire le
                    specifiche del veicolo.
                    <br />
                    <br />
                    Modellazione elettrica, termica, meccanica di ogni
                    componente del veicolo.
                  </p>
                </div>
              </div>
            </div>
            <div className="max-h-min">
              <img
                src={bannerDesktop}
                alt=""
                className="hidden overflow-hidden lg:block"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Servizi;
